import { z } from 'zod/v4'

import { defineScreen, type ScreenData } from '../define-screen.js'
import { freshnessSchema } from '../freshness.js'
import { screenSection } from '../section.js'

/*
 * «Correo › Plantillas»: every platform and organization template in one answer. Each schema mirrors
 * `EmailTemplate` / `EmailVariable` of `contracts/admin/email.types.ts` (the type assertions of
 * `shared-email-templates-screen.type-assertions.ts` tie them in both directions). `createdBy` / `lastModifiedBy` are
 * `null` in the seeded system templates; the variables are copied field by field because the column is `jsonb`.
 */

export const adminEmailVariableSchema = z.strictObject({
  name: z.string(),
  description: z.string().optional(),
  required: z.boolean().optional(),
  example: z.string().optional(),
})

export const adminEmailTemplateRowSchema = z.strictObject({
  id: z.string(),
  tenantId: z.string().nullable(),
  tenantName: z.string().nullable().optional(),
  code: z.string(),
  name: z.string(),
  subject: z.string(),
  bodyHtml: z.string(),
  bodyText: z.string().nullable(),
  variables: z.array(adminEmailVariableSchema).nullable(),
  isActive: z.boolean(),
  isSystem: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  createdBy: z.string().nullable(),
  lastModifiedBy: z.string().nullable(),
})

export const adminEmailTemplatesScreen = defineScreen({
  id: 'admin.email.templates',
  path: '/api/screens/admin/email/templates',
  access: 'super_admin',
  query: z.strictObject({}),
  response: z.strictObject({
    templates: screenSection(z.array(adminEmailTemplateRowSchema)),
    freshness: freshnessSchema,
  }),
  dependsOn: ['admin.email.templates'],
  budget: { requests: 1, statements: 3, bytes: 400_000, p95Ms: 300 },
  summary: 'E-mail templates: every platform and organization template with its variables',
})
export type AdminEmailTemplateRow = z.infer<typeof adminEmailTemplateRowSchema>
export type AdminEmailTemplatesData = ScreenData<typeof adminEmailTemplatesScreen>
